// @flow
import React from 'react'
import Modal from '../modal'
import Buy from '@components/app/buy'

interface Props {
  isOpen: boolean
  category: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
  onClose: () => void
}

const BuyModal = ({ isOpen, category, data, onClose }: Props) => (
  <Modal isOpen={isOpen} contentLabel="Buy" onRequestClose={onClose}>
    <Buy category={category} data={data} onCancel={onClose} />
  </Modal>
)

export default BuyModal
